import { createContext } from "react";

// set the defaults
const PermissionContext = createContext({ permission: null });

export default PermissionContext;